import { useEffect, useState } from 'react';

export default function HeroPretAPorter() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative w-full h-[60vh] min-h-[450px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional-tailor-working-modern-sewing-workshop-elegant-minimalist-interior-measuring-tape-fabrics-tools-organized-clean-space-soft-natural-lighting-warm-tones-editorial-photography&width=1920&height=1080&seq=104&orientation=landscape"
          alt="Taller de arreglos profesionales"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/35" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-16 md:pb-20 px-6 lg:px-[7%]">
        <div
          className={`transition-all duration-1000 ease-out ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="font-sans text-white/60 text-[11px] tracking-[0.2em] uppercase font-medium">
            Prêt-à-porter
          </span>
          <h1 className="font-serif text-white text-[clamp(2.5rem,6vw,5rem)] font-light leading-[1.05] mt-4 max-w-3xl">
            Arreglos
            <span className="block italic font-light mt-1">Profesionales</span>
          </h1>
          <p className="font-sans text-white/85 text-base md:text-lg max-w-xl leading-relaxed mt-6">
            Servicio rápido y eficiente en el corazón de Barcelona.
            Ajustes, reparaciones y personalización con la misma calidad artesanal de nuestra alta costura.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-6">
            <span className="flex items-center gap-2 font-sans text-white/80 text-sm">
              <i className="ri-time-line text-white/60" />
              1-7 días de entrega
            </span>
            <span className="flex items-center gap-2 font-sans text-white/80 text-sm">
              <i className="ri-shield-check-line text-white/60" />
              Garantía de calidad
            </span>
            <span className="flex items-center gap-2 font-sans text-white/80 text-sm">
              <i className="ri-map-pin-line text-white/60" />
              Rambla de Catalunya, 85, Principal - 2, Eixample
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}